import { jwtDecode } from 'jwt-decode';

export const getToken = () => {
  let auth = localStorage.getItem('auth');
  if (auth) {
    return jwtDecode(auth);
  }
};
